module.exports = __webpack_public_path__ + "img/a1_2_E.dfd6b6f8.jpg";